<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Ver documento -->
        <el-dropdown-item command="quote-view-doc">
          <i class="el-icon-view"></i> Ver documento
        </el-dropdown-item>

        <!-- 2. Enviar documento -->
        <el-dropdown-item command="quote-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Convertir en factura -->
        <el-dropdown-item
          v-if="
            status === 'draft' ||
              status === 'pending' ||
              status === 'partial' ||
              status === 'preapproved'
          "
          command="quote-convert-invoice"
        >
          <i class="el-icon-document-checked"></i> Convertir en factura
        </el-dropdown-item>

        <!-- Editar -->
        <el-dropdown-item
          v-if="status === 'draft' || status === 'pending'"
          command="quote-edit"
        >
          <i class="el-icon-edit"></i> Editar
        </el-dropdown-item>

        <!-- Cambiar a pendiente (desde preapproved) -->
        <el-dropdown-item
          v-if="status === 'preapproved'"
          command="quote-change-status-pending"
        >
          <i class="el-icon-refresh-left"></i> Cambiar a pendiente
        </el-dropdown-item>

        <!-- Cierre manual: aprobada / no aprobada (sin generar factura) -->
        <el-dropdown-item
          v-if="canCloseManually"
          command="quote-change-status-success"
          divided
        >
          <i class="el-icon-circle-check"></i> Marcar como aprobada
        </el-dropdown-item>

        <el-dropdown-item
          v-if="canCloseManually"
          command="quote-change-status-deny"
        >
          <i class="el-icon-circle-close"></i> Marcar como no aprobada
        </el-dropdown-item>

        <!-- Recordatorios de seguimiento -->
        <el-dropdown-item command="quote-toggle-reminders" divided>
          <i class="el-icon-bell"></i>
          {{ reminders ? "Pausar recordatorios" : "Activar recordatorios" }}
        </el-dropdown-item>

        <!-- Descargar PDF -->
        <el-dropdown-item command="quote-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Eliminar (siempre al final) -->
        <el-dropdown-item
          v-if="status === 'draft' || status === 'pending'"
          command="quote-delete"
          divided
        >
          <i class="el-icon-delete"></i> Eliminar
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="onCloseDocumentSendDrawer"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="quote && quote.client ? quote.client.id : null"
      :recipientName="quote && quote.client ? quote.client.name : ''"
      :messageableType="'quote'"
      :messageableId="id"
      :moduleType="'quote'"
      :draftKey="'draft-quote-' + id"
    />
    <Preview
      :quote="quote"
      :idVersion="idVersion"
      :showModal="quotePreview"
      :status="status"
      @close="handleCommand('quote-preview')"
      @action="handlePreviewAction"
    />
  </div>
</template>
<style lang="scss" scoped>
.img-sm {
  width: 0.8rem !important;
}
</style>
<script>
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import quoteService from "../services/quoteService";
import Preview from "./QuotePreview.vue";
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import { signingEventBus } from "@/services/signingEventBus";

import { downloadFile } from "@/assets/utils/files";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconDownload,
  iconCheck,
  icoPreview,
  icoInvoice
} from "@/services/resources";

export default {
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      iconDownload,
      iconCheck,
      icoPreview,
      icoInvoice,
      quote: null,
      reminders: false,
      quotePreview: false,
      visibleDocumentSend: false,
      visibleDocumentHistoryEmail: false
    };
  },
  watch: {
    enableReminders: {
      immediate: true,
      handler(val) {
        this.reminders = !!val;
      }
    }
  },
  props: {
    status: { default: null },
    id: { default: null },
    idVersion: { default: null },
    enableReminders: { type: Boolean, default: false }
  },
  computed: {
    // Cierre manual solo mientras la cotización sigue abierta. Ya aprobada,
    // rechazada o facturada (partial/success) no se toca desde aquí.
    canCloseManually() {
      return ["draft", "pending", "preapproved"].includes(this.status);
    },
    toMails() {
      if (!this.quote) return [];
      const { client, contact } = this.quote;
      if (contact && contact.email) return [contact.email];
      if (client && client.email) return [client.email];
      return [];
    },
    toPhone() {
      if (!this.quote) return "";
      const { client, contact } = this.quote;
      if (contact && contact.phone) return String(contact.phone).trim();
      if (client && client.phone) return String(client.phone).trim();
      return "";
    }
  },
  methods: {
    toggleApiResponse(property, value) {
      this.apiResponse[property] = value;
    },

    async getQuote(quoteId) {
      try {
        let response = await quoteService.getQuoteId(quoteId).finally(() => {});
        const { success, quote } = response.data;
        if (success) {
          this.quote = quote;
          this.toggleApiResponse("success", true);
        }
      } catch (error) {
        return false;
      }
    },

    handlePreviewAction(command) {
      const closeFirst = [
        "quote-view-doc",
        "quote-edit",
        "quote-convert-invoice"
      ];
      if (closeFirst.includes(command)) {
        this.quotePreview = false;
      }
      if (command === "quote-send") {
        this.dimPreview(true);
      }
      this.$nextTick(() => {
        this.handleCommand(command);
      });
    },
    dimPreview(dim) {
      const el = document.querySelector(".qpf-fullscreen");
      if (el) el.style.zIndex = dim ? "1" : "2100";
    },
    handleCommand(command) {
      if (this.quote == null && command !== "quote-delete") {
        this.getQuote(this.id);
      }

      switch (command) {
        case "quote-preview":
          this.quotePreview = !this.quotePreview;
          break;
        case "quote-view-doc":
          this.$emit("goPage", "sales.quotes.view", {
            id: this.id,
            idVersion: this.idVersion
          });
          break;
        case "quote-edit":
          this.$emit("goPage", "sales.quotes.edit", {
            id: this.id,
            idVersion: this.idVersion
          });
          break;
        case "quote-send":
          this.visibleDocumentSend = true;
          break;
        case "quote-convert-invoice":
          this.$emit("sendDoc");
          break;
        case "quote-history-email":
          this.visibleDocumentHistoryEmail = true;
          break;
        case "quote-download":
          this.quoteDownload();
          break;
        case "quote-delete":
          this.quoteDelete();
          break;
        case "quote-change-status-pending":
          this.updateQuoteStatus("pending");
          break;
        case "quote-change-status-success":
          this.confirmStatusChange("success");
          break;
        case "quote-change-status-deny":
          this.confirmStatusChange("deny");
          break;
        case "quote-toggle-reminders":
          this.toggleReminders(!this.reminders);
          break;
      }
    },

    onCloseDocumentSendDrawer() {
      this.visibleDocumentSend = false;
      this.dimPreview(false);
    },
    onCloseDocumentSendEmailHistory() {
      this.visibleDocumentHistoryEmail = false;
    },
    onDocumentSend({ data }) {
      data.append("quote_id", this.quote.id);
      data.append("quote_version_id", this.idVersion);

      this.sendQuoteEmail({ data });
    },
    async confirmStatusChange(status) {
      const isApprove = status === "success";
      try {
        await this.$confirm(
          isApprove
            ? "La cotización quedará como aprobada y se detendrán los recordatorios. No se genera ninguna factura."
            : "La cotización quedará como no aprobada y se detendrán los recordatorios.",
          isApprove ? "Marcar como aprobada" : "Marcar como no aprobada",
          {
            confirmButtonText: isApprove ? "Sí, aprobar" : "Sí, marcar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        );
      } catch (e) {
        return; // cancelado por el usuario
      }
      this.updateQuoteStatus(status);
    },
    async toggleReminders(val) {
      const previous = this.reminders;
      this.reminders = val;
      try {
        await quoteService.updateReminders(this.id, { enable_reminders: val });
        this.$emit("remindersChanged", { quoteId: this.id, enabled: val });
        this.$notifications.success({
          message: val
            ? "Recordatorios de seguimiento activados"
            : "Recordatorios de seguimiento pausados"
        });
      } catch (error) {
        this.reminders = previous;
        this.$notifications.error({
          message: "No se pudo actualizar los recordatorios"
        });
      }
    },
    async updateQuoteStatus(status) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const response = await quoteService
          .updateQuoteStatus(this.id, { status })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({
            message: message || "Estado actualizado"
          });
          // Aprobar/rechazar corta el seguimiento en backend: reflejarlo en la UI.
          if (status === "success" || status === "deny") {
            this.reminders = false;
            this.$emit("remindersChanged", {
              quoteId: this.id,
              enabled: false
            });
          }
          // Notifica al listado (usa el mismo bus que ya escucha QuoteColumns)
          signingEventBus.$emit("quote:status-changed", {
            quoteId: this.id,
            status
          });
        } else {
          this.$notifications.error({
            message: message || "No se pudo actualizar el estado"
          });
        }
      } catch (error) {
        this.$notifications.error({
          message:
            error?.response?.data?.message || "Error al actualizar el estado"
        });
      }
    },
    async quoteDownload() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService
          .downloadQuote({
            quoteId: this.id,
            quoteVersionId: this.idVersion
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });

        if (response) {
          downloadFile(response.data, `Cotización - #${this.quote.code}`);
        }
      } catch (error) {
        return false;
      }
    },

    async quoteDelete() {
      try {
        let response = await quoteService
          .deleteQuoteId(this.id)
          .finally(() => {});

        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({
            message
          });

          this.$store.dispatch("sendNotification", true);
        }
      } catch (error) {
        return false;
      }
    },

    async sendQuoteEmail({ data }) {
      const emailId = `email-quote-${Date.now()}`;
      const clientName = this.quote?.client?.name || "";
      const docNumber = this.quote?.code || "";

      this.visibleDocumentSend = false;
      this.dimPreview(false);

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Cotización #${docNumber}`
      });

      try {
        let response = await quoteService.sendQuoteEmail({ data });
        const { success, message, data: quote } = response.data;
        if (success) {
          this.quote = quote;
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Cotización #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    }
  },
  components: {
    IconMoreOptionComponent,
    Preview,
    WrapperSendDocumentDrawer
  }
};
</script>
